module.exports = __webpack_public_path__ + "static/media/faq-astrnt-small.f925057d.mp4";